import { split, HttpLink, ApolloClient, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';

const httpLink = new HttpLink({
    uri: 'https://app-server.debatemap.app/graphql'
});
const wsLink = new GraphQLWsLink(createClient({
    url: 'wss://app-server.debates.app/graphql',
    // connectionParams: {
    //   authToken: user.authToken,
    // },
}));

const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    httpLink
);
export const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache()
});
